import { render, staticRenderFns } from "./FixSmsStatements.vue?vue&type=template&id=14ccc961&scoped=true"
import script from "./FixSmsStatements.vue?vue&type=script&lang=js"
export * from "./FixSmsStatements.vue?vue&type=script&lang=js"
import style0 from "./FixSmsStatements.vue?vue&type=style&index=0&id=14ccc961&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ccc961",
  null
  
)

export default component.exports